import { Show, type JSX } from 'solid-js'

import { Spark } from '../charts'
import { Icon } from '../icons'
import Css from './ui.module.scss'

/**
 * Um numero grande com rotulo, icone e - quando ha - a mini-serie ao lado.
 *
 * Desenhado em DUAS telas sobre os mesmos valores - o painel da empresa e o do
 * paciente -, e por isso mora aqui.
 *
 * A serie e OPCIONAL desde 23/09/2026: o painel da empresa deixou de traze-la, com o
 * desenho do cliente, e no do paciente ela ficou - la o cartao e a unica serie que
 * aquela metrica tem na tela.
 */
export function MetricCard(props: {
    icon: string
    label: string
    value: string
    hint?: string
    spark?: readonly number[]
}): JSX.Element {
    return (
        <div class={Css.metric}>
            <div class={Css.metricTop}>
                <Icon name={props.icon} size={18} class={Css.metricIcon} />
                <span class={Css.metricLabel}>{props.label}</span>
            </div>

            <div class={Css.metricBase}>
                <div class={Css.metricTexts}>
                    <p class={Css.metricValue}>{props.value}</p>
                    <Show when={props.hint}>{(hint) => <p class={Css.metricNote}>{hint()}</p>}</Show>
                </div>
                <Show when={props.spark}>{(spark) => <Spark values={spark()} />}</Show>
            </div>
        </div>
    )
}
